import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForCheckInAfter_01days = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtCheckOutAfter01Days($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtCheckOutAfter01Days(input: $input) {
			userErrors
			success
		}
	}
`);
